import React from 'react';
import { ActivityIndicator, useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';
import Spacer from '../../components/Spacer';
import { H2, P } from '../../components/Typography';
import { usePasswordRecover } from '../../hooks/user/usePasswordRecover';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import Link from '../../components/Link';
import Button from '../../components/Button';
import { RouteProp, useRoute } from '@react-navigation/native';
import { IntroParamList } from '../../navigation/IntroNavigator';
import elementIDs from '../../../elementIDs';

const StyledView = styled.View<{ isDesktop: boolean }>`
  flex: 1;
  align-items: center;
  ${p => (p.isDesktop ? 'justify-content: center;' : '')}
`;

const StyledImageBackground = styled.ImageBackground`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const StyledForgotPasswordView = styled.View<{ isDesktop: boolean }>`
  width: 100%;
  height: 100%;
  padding: ${p => (p.isDesktop ? 0 : 87)}px 24px 40px 24px;
  ${p => (p.isDesktop ? 'max-height: 1080px;' : '')}
  justify-content: space-between;
`;

const StyledReturnLink = styled(Link)`
  text-align: center;
  width: 100%;
`;

const StyledHeaderView = styled.View<{ isDesktop: boolean }>`
  align-items: ${p => (p.isDesktop ? 'center' : 'flex-start')};
  align-self: center;
  max-width: 438px;
  width: 100%;
  margin-top: ${p => (p.isDesktop ? '100' : '0')}px;
`;

const StyledButtonView = styled.View<{ isDesktop: boolean }>`
  justify-content: space-between;
  align-items: ${p => (p.isDesktop ? 'center' : 'flex-start')};
  align-self: center;
  max-width: 438px;
  width: 100%;
`;

const ResetPasswordSentScreen: React.FC = () => {
  const window = useWindowDimensions();
  const isDesktop = window.width >= 768;
  const navigation = useNavigation<StackNavigationProp<any>>();
  const route =
    useRoute<RouteProp<IntroParamList, 'ResetPasswordSentScreen'>>();

  const { isLoading, doPasswordRecover } = usePasswordRecover();
  const handleSubmit = () => {
    doPasswordRecover(route.params.email);
  };

  return (
    <StyledView isDesktop={isDesktop}>
      <StyledImageBackground
        resizeMode='stretch'
        source={require('../../assets/intro/background.png')}
      />
      <StyledForgotPasswordView isDesktop={isDesktop}>
        <StyledHeaderView isDesktop={isDesktop}>
          <H2 color='dark' padding={2}>
            Email Sent
          </H2>
          <P color='dark' center={isDesktop}>
            Please check your email. We sent a link to reset your password.
          </P>
        </StyledHeaderView>
        <StyledButtonView isDesktop={isDesktop}>
          <Button
            style={{ width: '100%' }}
            testID={elementIDs.resendButtonID}
            onPress={() => handleSubmit()}
            disabled={isLoading}
            endIcon={
              isLoading && <ActivityIndicator size='small' color='white' />
            }
          >
            Resend Link
          </Button>
          <Spacer size={3} />
          <P center color='dark'>
            Didn’t receive an email? Check your spam folder or{' '}
            <Link
              inverse
              testID={elementIDs.tryAnotherEmailID}
              onPress={() => {
                navigation.pop();
              }}
            >
              try another email address
            </Link>
          </P>
          <Spacer size={3} />

          <StyledReturnLink
            inverse
            testID={elementIDs.emailSentReturnButtonID}
            onPress={() => {
              navigation.popToTop();
            }}
          >
            Return To Sign In
          </StyledReturnLink>
        </StyledButtonView>
      </StyledForgotPasswordView>
    </StyledView>
  );
};

export default ResetPasswordSentScreen;
